import Styles from "./News.module.scss";
import clsx from "clsx";
import { Fragment, useState, useEffect, useCallback, useRef } from "react";
import Select from "react-select";
import { adminUpdateNews } from "../../../Api/SubUrl";
import { NavLink } from "react-router-dom";
import { FcCopyright } from "react-icons/fc";
import { truncateText } from "../../../Share/Func/Handle";
import { Path } from "../../../Api/Path";
import { SwalError, SwalSuccess } from "../../../Share/Swal";
import Swal from "sweetalert2";
import { adminCreateNew } from "../../../Api/SubUrl";
import { BiEditAlt, BiTrash, BiExpand } from "react-icons/bi";
import { CallApiGetNews, CallApiDeleteNew } from "../../../Api/Enforcement";
import { clientNewsDetail } from "../../../Api/SubUrl";
import { NEW_TYPES } from "../../../Constants/news";
import PaginationComponent from "../../../Share/Component/Pagination";
import { initialPaging } from "../../../Constants/paging";

function CsrComponent({ data, shows, handleCalApi }) {
  const [show, setShow] = shows;

  const flagShow = "Y";

  const { showPropertiesCSR } = show;

  const handleOpenDrop = (event, value) => {
    event.preventDefault();
    setShow({ ...show, showPropertiesCSR: value });
  };

  const handleHideORShow = (id, flag) => {
    Swal.fire({
      title: flag === flagShow ? "Ẩn bài viết này" : "Hiện bài viết này",
      showCancelButton: true,
      confirmButtonText: "Đồng ý",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id);
      }
    });
  };

  const handleDelete = (id) => {
    CallApiDeleteNew(id, (res) => {
      if (res.Status === "success") {
        SwalSuccess("Đã xóa");
        handleCalApi();
      } else {
        SwalError("Lỗi không xác định\nLiên hệ để được hỗ trợ");
      }
    });
  };

  const handleChangPage = () => {
    const url = `${clientNewsDetail}${data.ID}`;
    window.open(url, "_blank"); // Opens the link in a new tab
  };

  return (
    <div
      onContextMenu={(e) => handleOpenDrop(e, data.ID)}
      className={clsx(Styles.cardWrap, "col-3")}
    >
      <div className={clsx(Styles.WrapBody)}>
        <div className={clsx(Styles.imgWrap)}>
          <img
            alt="img"
            src={Path.imageCDN + data.Img}
            className={clsx(Styles.imgSrc)}
          />
        </div>
        <div className={clsx(Styles.wrapTitle)}>
          <span className={clsx(Styles.title)}>{data.Title}</span>
          <br />
          <span className={clsx(Styles.description)}>
            {truncateText(data.shortText, 90)}
          </span>
        </div>
      </div>
      <FcCopyright className={clsx(Styles.icon)} />
      <div
        className={clsx(
          Styles.warpDropFD1,
          showPropertiesCSR === data.ID ? Styles.active : ""
        )}
      >
        <ul className={clsx(Styles.itemWrap)}>
          <li
            onClick={() => {
              handleChangPage();
            }}
            className={clsx(Styles.item)}
          >
            <NavLink className={clsx(Styles.item1)}>
              <div>
                <BiExpand className={clsx(Styles.iconItem)} />
                <span className={clsx(Styles.contentItem)}>Xem chi tiết</span>
              </div>
            </NavLink>
          </li>
          <li className={clsx(Styles.item)}>
            <NavLink
              to={`${adminUpdateNews}${data.ID}`}
              className={clsx(Styles.item1)}
            >
              <div>
                <BiEditAlt className={clsx(Styles.iconItem)} />
                <span className={clsx(Styles.contentItem)}>Sửa</span>
              </div>
            </NavLink>
          </li>
          <li
            onClick={() => handleHideORShow(data.ID, data.Flag)}
            className={clsx(Styles.item)}
          >
            <div>
              <BiTrash className={clsx(Styles.iconItem)} />
              <span className={clsx(Styles.contentItem)}>
                {data.Flag === flagShow ? "Ẩn bài viết" : "Hiện bài viết"}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

function AdminNews() {
  const [listNews, setListNews] = useState(null);
  const [show, setShow] = useState({
    showPropertiesCSR: false,
    showPropertiesESR: false,
  });
  const [paging, setPaging] = useState(initialPaging);
  const pagingRef = useRef(paging);

  const [type, setType] = useState(NEW_TYPES[0]);

  useEffect(() => {
    pagingRef.current = paging;
  }, [paging]);

  const handleCallApiNew = useCallback(
    (pageNum) => {
      const page =
        pageNum !== undefined ? pageNum : pagingRef.current.pageIndex;
      const param = {
        page: page,
        pageSize: 30,
        type: type.value,
        search: "",
      };
      CallApiGetNews(param, (res) => {
        if (res.Status === "success") {
          var data = res.Response.data;
          setListNews(data.Items);
          setPaging((prev) => ({
            ...prev,
            next: data.Next,
            previous: data.Previous,
            totalPages: data.TotalPagesCount,
            pageIndex: data.PageIndex,
          }));
        } else {
          SwalError("Lỗi không xác định\nLiên hệ để được hỗ trợ");
        }
      });
    },
    [type]
  );

  useEffect(() => {
    handleCallApiNew();
  }, [type, handleCallApiNew]);

  const handleCloseDrop = () => {
    setShow({ showPropertiesCSR: false, showPropertiesESR: false });
  };

  return (
    <div onClick={() => handleCloseDrop()} className={clsx(Styles.main)}>
      <div className={clsx(Styles.topMain)}>
        <h1 className={clsx(Styles.topMainTitle)}>Tin tức</h1>
      </div>
      <div className={clsx(Styles.bodyMain)}>
        <div className={clsx(Styles.bodyMainTop)}>
          <Select value={type} onChange={setType} options={NEW_TYPES} />

          <NavLink
            to={{ pathname: adminCreateNew }}
            className={clsx(Styles.btn)}
          >
            Tạo tin tức
          </NavLink>
        </div>
        <div className={clsx(Styles.mainWrap)}>
          <div className={clsx(Styles.listFileWrap)}>
            <div className={clsx(Styles.body, "container-fluid")}>
              <div className={clsx(Styles.bodyCsrRow, Styles.active, "row")}>
                {listNews && listNews.length > 0
                  ? listNews.map((item, index) => {
                      return (
                        <Fragment key={"news" + index}>
                          <CsrComponent
                            data={item}
                            shows={[show, setShow]}
                            handleCalApi={handleCallApiNew}
                          />
                        </Fragment>
                      );
                    })
                  : null}
              </div>
            </div>

            <PaginationComponent
              page={paging}
              handleCallApi={handleCallApiNew}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminNews;
